import { writable } from 'svelte/store';

function createStore(){
    const {subscribe, set, update} = writable({
        opened: false,
        component: null,
        data: null
    })

    return {
        subscribe,
        open: (component, data) => {
            update(u => ({
                opened: true,
                component: component,
                data: data
            }))
        },
        close: () => {
            update(u => ({
                opened: false,
                component: null,
                data: null
            }))
        }
    }
}

export const Modal = createStore();